import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Terren
 * id 2AD26260-A0C1-42BE-99A2-889F460EF25D
 * name home-circle-outline
 * version: 4.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-circle-outline.svg
 * tags
 * - Home Automation 
 */
export const HomeCircleOutlineIcon = createSvgIcon(<><path d="M12 20C7.6 20 4 16.4 4 12S7.6 4 12 4 20 7.6 20 12 16.4 20 12 20M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M11 14H13V17H16V12H18L12 7L6 12H8V17H11V14" /></>, 'HomeCircleOutlineIcon');
export default HomeCircleOutlineIcon